import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import SpeedDailDemo from "./components/SpeedDailDemo";
import PolicyIconsDemo from "./components/PolicyIconsDemo";
import ParNetsLoader from "./components/ParnetsLoader";
import LeadPopup from "./components/LeadPopup";
import AskAI from "./components/AskAI";

// Lazy loaded components
const LandingPage = React.lazy(() => import("./components/LandingPage"));
const Products = React.lazy(() => import("./components/Products"));
const ProductDetail = React.lazy(() => import("./components/ProductDetail"));
const Home2 = React.lazy(() => import("./components/Home2"));
const Service = React.lazy(() => import("./components/Service"));
const Projects = React.lazy(() => import("./components/Projects"));
const Career = React.lazy(() => import("./components/Career"));
const Contact = React.lazy(() => import("./components/Contact"));
const Industries = React.lazy(() => import("./components/Industries"));
const JoinUs = React.lazy(() => import("./components/JoinUs"));
const PrivacyPolicy = React.lazy(() => import("./components/PrivacyPolicy"));
const MaintenancePolicy = React.lazy(() => import("./components/MaintenancePolicy"));
const TermsAndCondition = React.lazy(() => import("./components/TermsAndCondition"));
const GoogleForm = React.lazy(() => import("./components/GoogleForm"));
const CaseStudies = React.lazy(() => import("./components/CaseStudies"));
const Blogs = React.lazy(() => import("./components/Blogs"));
const BlogDetail = React.lazy(() => import("./components/BlogDetail"));
const AskAIPage = React.lazy(() => import("./components/AskAIPage"));
const LeadsPage = React.lazy(() => import("./components/LeadsPage"));

// Wrapper that hides chrome (header/footer) on /ask-ai
const AppShell = () => {
  const location = useLocation();
  const isAIPage = location.pathname === "/ask-ai";
  const isLeadsPage = location.pathname === "/leads";

  return (
    <>
      <Toaster
        position="top-center"
        toastOptions={{ style: { padding: "16px", margin: "10px" } }}
      />

      {!isAIPage && !isLeadsPage && <Header />}
      {!isAIPage && !isLeadsPage && <LeadPopup />}

      <Suspense fallback={<ParNetsLoader />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/about" element={<Home2 />} />
          <Route path="/service" element={<Service />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/joinUs" element={<JoinUs />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/maintenancepolicy" element={<MaintenancePolicy />} />
          <Route path="/termsandcondition" element={<TermsAndCondition />} />
          <Route path="/salesupdate" element={<GoogleForm />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
          <Route path="/ask-ai" element={<AskAIPage />} />
          <Route path="/leads" element={<LeadsPage />} />
        </Routes>
      </Suspense>

      {!isAIPage && !isLeadsPage && <Footer />}
      {!isAIPage && !isLeadsPage && <SpeedDailDemo />}
      {/* {!isAIPage && !isLeadsPage && <PolicyIconsDemo />} */}
      {!isAIPage && !isLeadsPage && <AskAI />}
    </>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AppShell />
    </BrowserRouter>
  );
};

export default App;
